import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/star-theme.css'
import router from './router'
import i18n from './locales'
import websocketService from './services/websocket'

import { createPinia } from 'pinia'

// console.log = () => {} // 禁用 console.log

// function customLog(message, judge = false) {
//   if (judge) {
//     console.log(message)
//   }
// }

const app = createApp(App)
const pinia = createPinia() // 2. 创建Pinia实例

// 将WebSocket服务和通知管理器挂载到全局属性
app.config.globalProperties.$websocket = websocketService
// 动态加载通知管理器
// import('./services/notification').then(({ default: notificationManager }) => {
//   app.config.globalProperties.$notification = notificationManager
// })

// 在应用启动时初始化WebSocket连接
function initializeWebSocket() {
  const ticket = window.localStorage.getItem('ticket')

  if (ticket) {
    setTimeout(() => {
      websocketService.connect()
    }, 1000)
  } else {
    console.log('🚀 应用启动 - 未检测到认证票据，等待用户登录')
  }
}

app.use(ElementPlus)
app.use(i18n)
app.use(router)
app.use(pinia)

// 应用挂载完成后初始化WebSocket
app.mount('#app')

// 初始化WebSocket连接和监听
initializeWebSocket()

// 导出websocket服务和通知管理器供其他组件使用
export { websocketService }
